// extracted by mini-css-extract-plugin
export default {"card":"Card_card__uupO1","card_header":"Card_card_header__+-nQw","title":"Card_title__phkWC"};